/* eslint-disable @gorazdo/preact/prefer-classname */
import { h } from 'preact'
import { Modal, ModalBody, ModalFooter, ModalHeader } from '../../../preact-components/modal'
import ButtonControl from '../../../preact-components/button-control'

interface Props {
  customViewName: string,
  showModal: boolean,
  onDeleteCustomView: () => Promise<void> | void,
  onClose: () => void
}

const SaveCustomViewModal = (
  { customViewName, onDeleteCustomView, onClose, showModal }: Props) => {
  return (
    <Modal isOpen={showModal} size='medium'>
      <ModalHeader title={`Delete view ‘${customViewName}’?`} onClose={onClose} />
      <ModalBody>
        <p>If you delete a view, it's gone for good.</p>
      </ModalBody>
      <ModalFooter>
        <ButtonControl title='Delete' variant='warning' onClick={onDeleteCustomView} class='qa-delete-custom-view' newStyle size='medium' />
        <ButtonControl title='Cancel' onClick={onClose} newStyle size='medium' />
      </ModalFooter>
    </Modal>
  )
}

export default SaveCustomViewModal
